import React from "react";
import Text from "@/components/ui/text";

interface Props {
  labels: { title: string; description: string };
}

const NoLicensesEmptyState: React.FC<Props> = ({ labels }) => {
  return (
    <div className="flex flex-col items-center justify-center p-6 text-center">
      <Text variant="body" className="text-primary font-medium mb-2">
        {labels.title}
      </Text>
      <Text variant="bodySecondary" className="text-secondary">
        {labels.description}
      </Text>
    </div>
  );
};

export default NoLicensesEmptyState;
